import script from "./ViewClientNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewClientNotes.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./ViewClientNotes.vue?vue&type=style&index=1&id=074abad4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074abad4"]])

export default __exports__